// import aftersalesReplayList from './list'
const addmessage = {
  path: 'messageList/addmessage',
  component: resolve => require(['@/pages/admin/platform/message/messageList/addmessage'], resolve),
  meta: {
    requireAuth: true
  },
  children: [
    // aftersalesReplayList,
  ]
}

export default addmessage